import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { ButtonColors } from '../../../ui/gzButton/types';
import { SpinnerWidth } from '../../../ui/gzProgressSpinner/types';
import { TooltipSeverity } from '../../../ui/gzTooltip/types';
import { FontSizes, LineHeights } from '../../../types/common/types';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <gz-banner class='wrapper' logoCssClass='icon-GravityZone_MobileSec'>
    <gz-progress-spinner spinnerWidth='${SpinnerWidth.LARGE}'></gz-progress-spinner>

    <div id='no-account' class='sub-wrapper'>
      <gz-text id='create-text' lineHeight='${LineHeights.SMALL}' fontSize='${FontSizes.HEADING_5}'></gz-text>
      <gz-tooltip id='create-tooltip' tooltipClass='${TooltipSeverity.NEUTRAL}'>
        <gz-button id='create-button' color='${ButtonColors.PRIMARY}'></gz-button>
      </gz-tooltip>
    </div>

    <div id='with-account' class='sub-wrapper'>
      <gz-text id='console-text' lineHeight='${LineHeights.SMALL}' fontSize='${FontSizes.HEADING_5}'></gz-text>
      <gz-button id='console-button' color='${ButtonColors.PRIMARY}'></gz-button>

      <div id='expired-tooltip'>
        <span class='icon icon-fail notice'></span>
        <span id='expired-tooltip-text'></span>
      </div>

      <gz-text id='invitation-text' lineHeight='${LineHeights.SMALL}' fontSize='${FontSizes.HEADING_5}'></gz-text>
      <gz-button id='invitation-button' type='outline' color='${ButtonColors.SECONDARY}'></gz-button>
    </div>
  </gz-banner>
`;
